export default __webpack_public_path__ + "static/options-63363ebc0b9b20ecf2c5e417485b47d6.jpg";